import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/rehype-katex/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/boards.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/design.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/frames1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/frames2.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/hole-center.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/hole-side.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/holes.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/overview.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/paint.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/plan-after.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/plan-before.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/rail-measurements.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/rail-spec.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/rail.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2018/monitor-stand/sandpaper.jpg");
